<template>
  <div>
    <nav-breadcrumb :menu="[{label: '用户列表'}]"/>
    <div class="xzpadd10 bg-purple of">
<!--      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content">
            <el-select v-model="filterOptions['r__roleName']" :disabled="advancedSearch" placeholder="请选择">
              <el-option
                v-for="item in roleListOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content">
            <el-input v-model="filterOptions['u.userCode,u.userName']" placeholder="请输入内容"
                      :disabled="advancedSearch"></el-input>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content">
            <el-button type="primary" icon="el-icon-search" :disabled="advancedSearch" @click="handleSearch"
                       size="small">搜索
            </el-button>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content">
            <el-button type="primary" @click="advancedSearch = !advancedSearch" size="small">
              <element v-show="!advancedSearch">高级搜索</element>
              <element v-show="advancedSearch">快速搜索</element>
            </el-button>
          </div>
        </el-col>
        <el-col :span="1" :offset="8">
          <div class="grid-content">
            <router-link to="add">
              <el-button type="primary" size="small">新增用户</el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="advancedSearch" class="xzmb10">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="grid-content">
                <div class="search-add-item">
                  <div class="search-item-txt">用户名：</div>
                  <div class="search-item-con">
                    <el-input v-model="filterOptions['u__userCode']" placeholder="请输入内容"></el-input>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <div class="search-add-item">
                  <div class="search-item-txt">姓名：</div>
                  <div class="search-item-con">
                    <el-input v-model="filterOptions['u__userName']" placeholder="请输入内容"></el-input>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <div class="search-add-item">
                  <div class="search-item-txt">角色：</div>
                  <div class="search-item-con">
                    <el-select v-model="filterOptions['r.roleName']">
                      <el-option
                        v-for="item in roleListOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <div class="search-add-item">
                  <div class="search-item-txt">状态：</div>
                  <div class="search-item-con">
                    <el-select v-model="filterOptions['u__disabled']" placeholder="请选择">
                      <el-option
                        label="全部"
                        value="">
                      </el-option>
                      <el-option
                        label="启用"
                        value="N">
                      </el-option>
                      <el-option
                        label="禁用"
                        value="Y">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col>
              <div class="grid-content" style="text-align:right">
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button plain>清空</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
      <el-row :gutter="10">
        <el-collapse-transition>
          <div v-show="multipleSelection.length>0">
            <el-row>
              <el-col>
                <div>
                  <ul class="toolbar">
                    <li>已选中 {{multipleSelection.length}} 项</li>
                    <li><a href="#" class="el-icon-goods" @click.prevent="enableUsers()">启用</a></li>
                    <li><a href="#" class="el-icon-sold-out" @click.prevent="disableUsers()">禁用</a></li>
                    <li><a href="#" class="el-icon-delete" @click.prevent="deleteUsers()">删除</a></li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
        <el-row>
          <el-col>
            <div class="grid-content bg-purple xzpadd10">
              <el-table :data="userList.data" style="width: 100%" border @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="50">
                </el-table-column>
                <el-table-column label="用户名" align="center" width="180" prop="u__userCode">
                </el-table-column>
                <el-table-column label="姓名" align="center" width="180" prop="u__userName">
                </el-table-column>
                <el-table-column label="角色" align="left" prop="r__roleName">
                </el-table-column>
                <el-table-column label="创建时间" align="center" width="180" prop="u__createdDate"
                                 :formatter="function(r,c,v){return v.substring(0, v.length-2)}">
                </el-table-column>
                <el-table-column label="状态" align="center" width="100" prop="u__disabled">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.u__disabled" active-value="N" inactive-value="Y"
                               @change="toogleUserDisabled(scope.row)"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                  <template slot-scope="scope">
                    <el-tooltip content="编辑该用户">
                      <router-link :to="'edit?userId='+scope.row.u__userId" title="编辑用户" class="el-icon-edit"
                                   style="font-size:14px"></router-link>
                    </el-tooltip>
                    <el-tooltip content="重置密码">
                      <a href="" class="el-icon-refresh" @click.prevent="resetPassword(scope.row.u__userId)"
                         style="font-size:14px"></a>
                    </el-tooltip>
                    <el-tooltip content="删除该用户">
                      <a href="" class="el-icon-delete" @click.prevent="deleteUser(scope.row.u__userId)"
                         style="font-size:14px"></a>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </el-col>
        </el-row>
      </el-row>
      <pagination :total="userList.count" :pageSize="pageSize" :handleCurrentChange="handleCurrentChange"/>-->

      <data-table-component
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
      <el-dialog v-if="userFormDialogVisible" :visible.sync="userFormDialogVisible" title="重置密码" class="liangliang01" @close="dialogClose()">
          <form-build
              form-name="userForm"
              :form-data.sync="userForm"
              :form-columns="userFormColumns"
              :form-rules="userFormRules"
              :form-buttons="userFormButtons"
              style="width: 400px"
          ></form-build>
      </el-dialog>
  </div>
</template>
<script>
  import xhr from '@/utils/xhr'
  import Pagination from '@/components/Pagination'
  import DataTableComponent from "../../../components/DataTable";
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {removeItem, xmlBuildQuery} from "../../../filters/CommonActions";

  export default {
    data() {
      return {
        userList: [],
        roleList: {},
        page: 1,
        pageSize: 20,
        filterOptions: {},
        multipleSelection: [],
        advancedSearch: false,
        roleListOptions: [],
        tableData: {},
          userFormRules:{
              u__password: [
                  {
                      required: true,
                      message: '新密码不能为空！'
                  }
              ],
              u__passwordTwo: [
                  {
                      required: true,
                      message: '确认密码不能为空！'
                  }
              ],
              u__passwordNow: [
                  {
                      required: true,
                      message: '登录密码不能为空！'
                  }
              ],
          },
          userForm: {
              u__checked: true,
              u__userId:'',
              u__password: '',
              u__passwordTwo:'',
              u__passwordNow:''
          },
        columns:[
          {
            label: '用户名',
            field: 'u__userCode'
          },
          {
            label: '姓名',
            field: 'u__userName'
          },
          {
            label: '角色',
            field: 'r__roleName'
          },
          {
            label: '部门',
            field: 'd__departmentName'
          },
          {
            label: '创建时间',
            field: 'u__createdDate',
            formatter: (r,c,v)=>{
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '状态',
            field: 'u__disabled',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作',
            opts:[
              {
                label: '编辑用户',
                class: 'el-icon-edit',
                clickHandler: (index, row)=>{
                  this.$router.push(
                    {
                      path: 'edit',
                      query: {
                        userId: row.u__userId
                      }
                    }
                  )
                }
              },
              {
                label: '重置密码',
                class: 'el-icon-refresh',
                clickHandler: (index, row)=>{
                  /*this.resetPassword(row.u__userId)*/
                    this.userFormDialogVisible = true
                    this.userForm.u__userId = row.u__userId
                }
              },
              {
                label: '删除用户',
                class: 'el-icon-delete',
                clickHandler: (index, row)=>{
                  this.deleteUser(row.u__userId)
                }
              }
            ]
          }
        ],
          userFormDialogVisible:false,
        actions: [
          {
            label: '新增用户',
            class: 'el-button--primary',
            clickHandler:()=>{
              this.$router.push({
                path: 'add'
              })
            }
          }
        ],
        filters: {
          form: {
            u__userCode: '',
            u__userName: '',
            r__roleName: '',
            u__disabled: ''
          },
          columns: [
            {
              label: '用户名',
              component: 'el-input',
              field: 'u__userCode'
            },
            {
              label: '姓名',
              component: 'el-input',
              field: 'u__userName'
            },
            {
              label: '角色',
              component: 'el-select',
              field: 'r__roleName',
              options: this.roleListOptions
            },
            {
              label: '状态',
              component: 'el-select',
              field: 'u__disabled',
              options: [
                {
                  label: '全部',
                  value: ''
                },
                {
                  label: '启用',
                  value: 'N'
                },
                {
                  label: '禁用',
                  value: 'Y'
                }
              ]
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getUserList()
          }
        },
          userFormButtons: [
              {
                  label: '确认',
                  type: 'primary',
                  clickHandler: $refs => {
                      let that = this
                      $refs.validate(valid => {
                          if(valid){
                              if (this.userForm.u__password===this.userForm.u__passwordTwo) {
                                  xhr.resetPassword({
                                      'u__userId': this.userForm.u__userId,
                                      'u__password': this.userForm.u__password,
                                      'a__password': this.userForm.u__passwordNow
                                  }, function (res) {
                                      if (res.data.status == 'success') {
                                          that.userFormDialogVisible = false
                                          that.userForm.u__userId = ''
                                          that.userForm.u__password = ''
                                          that.userForm.u__passwordNow = ''
                                          that.userForm.u__passwordTwo = ''
                                          that.userFormDialogVisible = false
                                          that.$message({
                                              type: 'success',
                                              message: '重置密码成功！'
                                          });

                                      }
                                      else {
                                          that.$message({
                                              type: 'error',
                                              message: res.data.msgs[0].text
                                          });
                                      }

                                  })
                              }else{
                                  this.$message({
                                      type: 'error',
                                      message: '确认密码输入不一致'
                                  });
                              }
                          }
                      })
                  }
              },
              {
                  label: '取消',
                  // type: 'danger',
                  clickHandler: $refs => {
                      this.userFormDialogVisible = false
                      this.userForm.u__userId = ''
                      this.userForm.u__password = ''
                      this.userForm.u__passwordNow = ''
                      this.userForm.u__passwordTwo = ''
                  }
              }
          ],
      }
    },
    watch: {
      filterParams: function (val) {
        this.getUserList()
      },
      advancedSearch: function (val) {
        this.page = 1
        this.filterOptions = {}
        this.getUserList()
      },
    },
    computed: {
      // filterParams: function () {
      //   let params = {}
      //
      //   for (let k in this.filterOptions) {
      //     let option = this.filterOptions[k]
      //     if (typeof option == 'object' && option.length > 0) {
      //       for (let i in option) {
      //         params['xlist.search.' + k + '[' + (i) + ']'] = option[i]
      //         params['xlist.search.' + k + '[' + (i) + '].op'] = 'like'
      //       }
      //     }
      //     else {
      //       params['xlist.search.' + k] = option
      //       params['xlist.search.' + k + '.op'] = 'like'
      //     }
      //   }
      //   params.page = this.page
      //   params.pageSize = this.pageSize
      //   params['xlist.sort.dataField'] = 'u.createdDate'
      //   params['xlist.sort.order'] = 'asc'
      //
      //   return params
      // },
      filterParams: {
        get: function () {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'u.createdDate',
            'xlist.sort.order': 'asc'
          }
        },
        set:function (newVal) {

        }
      },
        userFormColumns: {
            get() {
                return [
                    {
                        label: '输入当前账号密码',
                        component: 'el-input',
                        field: 'u__passwordNow',
                        type:'password',
                        span: 24,
                    },
                    {
                        label: '设置新密码',
                        component: 'el-input',
                        field: 'u__password',
                        type:'password',
                        span: 24,
                    },
                    {
                        label: '确认密码',
                        component: 'el-input',
                        field: 'u__passwordTwo',
                        type:'password',
                        span: 24,
                    },
                ]
            }
        },
    },
    mounted: function () {
      this.getUserList()
      this.getRoleList()
    },
    components: {
      DataTableComponent,
      Pagination
    },
    methods: {
        dialogClose:function(){
            this.userForm.u__userId = ''
            this.userForm.u__password = ''
            this.userForm.u__passwordNow = ''
            this.userForm.u__passwordTwo = ''
        },
      //获取用户列表
      getUserList: function () {
        console.log(this.filters)
        xhr.getUserList(
          Object.assign(
            {},
            this.filterParams,
            xmlBuildQuery(this.filters)
          ),
          res=> {
            this.tableData = res.data
          }
        )
      },
      //获取角色列表
      getRoleList: function () {
        xhr.getRoleList(
          {
            pageSize: 100
          },
          res => {
            try {
              if (res.data.status == 'success') {
                this.roleListOptions = res.data.data.map(item => {
                  return {
                    label: item.r__roleName,
                    value: item.r__roleName
                  }
                })
                this.filters.columns.map(item=>{
                  if(item.field == 'r__roleName') {
                    item.options = this.roleListOptions
                  }
                })
                console.log(this.filters)
              }
            } catch (e) {

            }

          }
        )
      },
      //切换用户禁用状态
      toogleUserDisabled: function (userInfo) {
        if (userInfo.u__disabled == 'N') {
          this.enableUser(userInfo.u__userId)
        }
        else {
          this.disableUser(userInfo.u__userId)

        }
      },
      enableUsers: function () {
        let users = this.multipleSelection.map(item => item['u__userId'])
        this.enableUser(users)
      },
      disableUsers: function () {
        let users = this.multipleSelection.map(item => item['u__userId'])
        this.disableUser(users)
      },
      enableUser: function (users) {
        let that = this
        typeof users === 'object' && (users = users.join(','))
        xhr.enableUser({users}, function (res) {
          that.getUserList()
        })
      },
      disableUser: function (users) {
        let that = this
        typeof users === 'object' && (users = users.join(','))
        xhr.disableUser({users}, function (res) {
          that.getUserList()
        })
      },
      //删除
      deleteUser: function (users) {

        removeItem(
          xhr.deleteUser,
          {
            users
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getUserList()
              }
            }catch (e) {

            }
          }
        )

      /*  let that = this
        this.$confirm('此操作将永久删除选中的账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          xhr.deleteUser({users}, res => {
            that.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          that.getUserList()
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });
        });*/
      },
      //批量删除
      deleteUsers: function () {
        let users = this.multipleSelection.map(item => item['u__userId'])
        this.deleteUser(users)
      },
      //重置密码
      resetPassword: function (userId) {
        let that = this
        this.$prompt('请输入新密码！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.{6}/,
          inputErrorMessage: '密码长度不低于6位'
        }).then(({value}) => {
          xhr.resetPassword({
            'u__userId': userId,
            'u__password': value

          }, function (res) {
            if (res.data.status == 'success') {
              that.$message({
                type: 'success',
                message: '重置密码成功！新密码： ' + value
              });
            }
            else {
              that.$message({
                type: 'info',
                message: '重置密码失败！'
              });
            }

          })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '取消操作'
          });
        });
      },
      handleSelectionChange: function (val) {
        this.multipleSelection = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigUserList.vue